import APIGet from '../../../API/APIGet';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
import AppConfig from '../../../AppConfig';

export const FitVisaTab = ({ travelerId }) => {
	const [programs, setPrograms] = useState([]);

	useEffect(() => {
		APIGet('travelers/' + travelerId + '/fitVisas').then(response => {
			setPrograms(response.data || []);
		});
	}, [travelerId]);
	return (
		<div className="table-container" style={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
			<table className="table is-fullwidth is-hoverable travelers-table">
				<thead className="table-header-travelers">
					<tr>
						<th width="60%" className="travelers-table-header-left">
							FIT name ({programs.length})
						</th>
						<th width="40%">สร้างเมื่อ</th>
					</tr>
				</thead>
				<tbody>
					{programs.length > 0 ? (
						programs.map(item => (
							<tr key={item.id}>
								<td>
									<Link className="travelers-row-link" to={AppConfig.appPath + '/programs/fit/' + item.id}>
										{item.title}
									</Link>
								</td>
								<td>{moment(item.createdAt).format('D MMM YYYY HH:mm')}</td>
							</tr>
						))
					) : (
						<tr>
							<td colSpan="2" style={{ textAlign: 'center' }}>
								ไม่มีข้อมูล
							</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};
